<script>

    import Section from '../../components/pagesbuilder/sections/Section'    
    import PreviewNodeState from "../mixins/PreviewNodeState";
    import PreviewVisibilityMixin from '../../author/pagesbuilder/mixins/PreviewVisibilityMixin';
    

    export default {
        name: "PreviewSection",
        mixins: [
            PreviewVisibilityMixin,
            PreviewNodeState,
            Section
        ],
        methods: {
            sectionCreationCompleteCallback () {
                this.checkAnimationTrigger();
                if(typeof this.checkVisibility !== 'undefined'){
                    this.checkVisibility();
                }

                if ( this.myData && this.myData.selectedMedia === "Video") {
                    this.renderVideo();
                }
            },
            handleRegistrationWithTempId () {
                //when handling the tempId we need to create a new sectionId which we are going to init the element with and also change the registrationData to include the new Id there and remove the temp
                //also check if the tempId was used for a newly inserted element or an element that exists in the DOM
                let newSectionId = this.createSectionId();

                this.editRegisteredSection({
                    action: "replaceTempId",
                    tempId: this.registrationData.tempId,
                    sectionId: newSectionId
                })

                //when a section is found as a node without an id
                if (this.registrationData.sectionNode) {
                    return new Promise( (resolve,reject) => {
                        this.sectionNode = this.registrationData.sectionNode;
                        this.sectionNode.id = newSectionId;
                        this.sectionId = newSectionId;
                        this.sectionTemplateId = this.registrationData.sectionTemplateId;
                        resolve();
                    })
                }
            },
            handleRegistrationWithExistingId () {
                return new Promise( (resolve,reject) => {
                    this.sectionNode = this.registrationData.sectionNode;                    
                    this.sectionId = this.sectionNode.id;
                    this.sectionTemplateId = this.registrationData.sectionTemplateId;
                    resolve();
                })
            },
            insertVideo (videoWrapper,frame) {
                let frameRatioWrapper = this.getBgFrameRatioWrapper();

                if (!frameRatioWrapper) {
                    frameRatioWrapper = document.createElement('div');
                    frameRatioWrapper.classList.add("js-background-frame-wrapper");
                    frameRatioWrapper.setAttribute("style","position:relative;height:100%;overflow:hidden");
                    frameRatioWrapper.appendChild(frame);
                    videoWrapper.appendChild(frameRatioWrapper);
                } else {
                    this.removeVideo(videoWrapper);
                    frameRatioWrapper.appendChild(frame);
                }

                frameRatioWrapper.style.pointerEvents = 'none';

                this.$nextTick(function () {
                    this.backgroundFrameDimensions(frame);
                }.bind(this));
            }
        },
    }
</script>
